module.exports = __webpack_public_path__ + "static/media/Muli-Bold.e004c490.ttf";